import { createSlice } from "@reduxjs/toolkit";

const initialStoreState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  storeForEdit: undefined,
  lastError: null,
  message: null,
  currentTab: "overview",
  error: null,
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const storeSlice = createSlice({
  name: "stores",
  initialState: initialStoreState,
  reducers: {
    catchError: (state, action) => {
      state.error = action.payload.error.clientMessage;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      state.message = null;

      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    endCall: (state, action) => {
      state.error = null;
      state.message = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    // getStoreById
    storeFetched: (state, action) => {
      state.actionsLoading = false;
      state.storeForEdit = action.payload.storeForEdit;
      state.floorPlans = action.payload.storeForEdit.floorPlans;
      state.error = null;
    },
    // getStoreChart
    storeChartFetched: (state, action) => {
      state.actionsLoading = false;
      state.storeChart = action.payload.storeChart;
      state.error = null;
    },
    // getStoreChart
    storeHourlyChartFetched: (state, action) => {
      state.actionsLoading = false;
      state.storeChartHour = action.payload.storeChartHour;
      state.error = null;
    },
    // getStoreChart
    storeHourlyZoneChartFetched: (state, action) => {
      state.actionsLoading = false;
      state.storeChartHourZone = action.payload.storeChartHourZone;
      state.error = null;
    },
    // get list data
    storesFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
      state.storeForEdit = undefined;
      state.floorPlans = undefined;
      state.storeChart = undefined;
      state.storeChartHour = undefined;
      state.storeChartHourZone = undefined;
    },
    // createStore
    storeCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.message = action.payload.msgResponse;
    },
    // updateStore
    storeUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.message = action.payload.msgResponse;
    },
    // storeDeleted
    storeDeleted: (state, action) => {
      state.error = null;
      state.message = action.payload.msgResponse;
      state.actionsLoading = false;
    },
    setMessage: (state, action) => {
      state.error = null;
      state.message = action.payload.msgResponse;
    },
    setTab: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.currentTab = action.payload.tab;
    },
    userCreated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.message = action.payload.msgResponse;
    },
  },
});
